import React from "react";
import { RouteChildrenProps } from "react-router";
import { ContentList } from "../../components/content-types/ContentList";

export function PostList(props: RouteChildrenProps) {
  return (
    <ContentList
      type="post"
      onCreate={() => props.history.push(`/posts/create`)}
    />
  );
}
